import { useOverview, useTraffic, useFeatures, useRegions, useReleaseBands } from '../lib/api-client'
import { LoadingCard } from '../components/LoadingSpinner'
import { TrafficOverviewChart } from '../components/charts/TrafficOverviewChart'
import { FeatureBreakdownChart } from '../components/charts/FeatureBreakdownChart'
import { RegionDistributionChart } from '../components/charts/RegionDistributionChart'
import { useDateRange } from '../components/Layout'
import { MetricCard, ChartCard } from '../components/ui'

export function Dashboard() {
  const { startDate, endDate } = useDateRange()

  const overview = useOverview(startDate, endDate)
  const traffic = useTraffic(startDate, endDate)
  const releaseBands = useReleaseBands(startDate, endDate)
  const features = useFeatures(startDate, endDate)
  const regions = useRegions(startDate, endDate)

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-foreground">Dashboard Overview</h2>

      {/* Overview Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <MetricCard
          title="Total Events"
          value={overview.data?.data.total_events}
          isLoading={overview.isLoading}
        />
        <MetricCard
          title="Page Views"
          value={overview.data?.data.page_views}
          isLoading={overview.isLoading}
        />
        <MetricCard
          title="Unique Visitors"
          value={overview.data?.data.unique_visitors}
          isLoading={overview.isLoading}
        />
        <MetricCard
          title="Active Days"
          value={overview.data?.data.active_days}
          isLoading={overview.isLoading}
        />
      </div>

      {/* Charts Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Traffic Chart */}
        <ChartCard title="Traffic Over Time">
          {traffic.isLoading ? (
            <LoadingCard />
          ) : traffic.data ? (
            <TrafficOverviewChart
              data={traffic.data.data}
              releaseBands={releaseBands.data?.data}
            />
          ) : (
            <p className="text-muted-foreground">No data available</p>
          )}
        </ChartCard>

        {/* Features Chart */}
        <ChartCard title="Feature Usage">
          {features.isLoading ? (
            <LoadingCard />
          ) : features.data ? (
            <FeatureBreakdownChart data={features.data.data} />
          ) : (
            <p className="text-muted-foreground">No data available</p>
          )}
        </ChartCard>

        {/* Regions Chart */}
        <ChartCard title="Geographic Distribution" className="lg:col-span-2">
          {regions.isLoading ? (
            <LoadingCard />
          ) : regions.data ? (
            <RegionDistributionChart data={regions.data.data} />
          ) : (
            <p className="text-muted-foreground">No data available</p>
          )}
        </ChartCard>
      </div>

      {/* Cache Info */}
      {overview.data?.meta && (
        <p className="text-xs text-muted-foreground text-right">
          {overview.data.meta.cached
            ? `Cached at ${new Date(overview.data.meta.cached_at!).toLocaleString()}`
            : `Fresh data (${overview.data.meta.query_time_ms}ms)`}
        </p>
      )}
    </div>
  )
}
